import { render, staticRenderFns } from "./AgreementComponent.vue?vue&type=template&id=002dfc13"
import script from "./AgreementComponent.vue?vue&type=script&lang=js"
export * from "./AgreementComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports